module.exports = __webpack_public_path__ + "img/logo_nacex.677e2bbc.png";